var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"p-0 m-0"},[_c('b-card',{ref:"displayCard",class:_vm.backgroundColor,style:({ width: _vm.cardWidthString, height: _vm.cardHeightString }),attrs:{"no-body":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }